import UIFetchService from '../Service/UIFetchService';
import auth from '../Service/AuthFetchService';
import { isEmpty } from '../Service/Utils';

import React from 'react';
import { Row, Col, Button, Modal, Table, Form, Space, message, Input, Select } from 'antd';
import { UserOutlined } from '@ant-design/icons';

class MeasureDescView extends React.Component {
    constructor() {
        super();

        const delta = document.body.clientHeight - 830;
        this.state = {
            detailModal: {
                title: '',
                readonly: true,
                visible: false,
                value: {}
            },
            tableHeight: document.body.clientHeight - delta
        };
    }

    async componentDidMount() {
        const coreMeasure = await UIFetchService.get('/api/v1/metadata/measure/core/desc');
        this.setState({ coreMeasure });

        await auth.authenticate();

        window.onresize = () => {
            const delta = (auth.allow("datap:admin") ? 130 : 90);
            this.setState({ tableHeight: document.body.clientHeight - delta });
        };
        window.onresize();
    }

    componentWillUnmount() {
        window.onresize = undefined;
    }

    buColors = {
        '薄荷芝士派': '#eb2f96',
        '柚子鸭': '#d4b106',
        '百词斩': '#2f54eb',
        '夜曲编程': '#391085',
        '蛋糕英语': '#ffc53d'
    };

    areaColors = {
        '用户域': '#7cb305',
        '交易域': '#faad14',
        '流量域': '#1890ff',
        '课程域': '#722ed1',
    };

    categoryColors = {

    };

    render() {
        return <>
            {auth.allow("datap:admin") && <>
                <Row>
                    <Col>
                        <Button type="primary" onClick={() => this.showMeasureDetail({}, false)} >增加指标</Button>
                    </Col>
                </Row>
                <div style={{ height: 10 }} />
            </>}
            <Row>
                <Table
                    dataSource={this.state.coreMeasure}
                    pagination={false}
                    bordered
                    size="small"
                    style={{
                        width: '100%',
                        height: this.state.tableHeight,
                        overflowX: 'auto',
                        overflowY: 'auto'
                    }}
                    onRow={record => {
                        return {
                            onDoubleClick: _ => {
                                this.showMeasureDetail(record, true);
                            }
                        };
                    }}
                    onChange={()=>{
                        window.onresize();
                    }}
                >
                    <Table.Column
                        dataIndex="name"
                        key="name"
                        width={200}
                        fixed="left"
                        ellipsis
                        title="指标名称"
                        render={value=><strong>{value}</strong>}
                    />
                    {/* <Table.Column dataIndex="alias" key="alias" width={200} title="别名" /> */}
                    <Table.Column
                        dataIndex="category"
                        key="category"
                        width={100}
                        title="所属赛道"
                        filters={
                            [{
                                text: '*通用*',
                                value: '通用'
                            }, {
                                text: '成人赛道',
                                value: '成人赛道'
                            }, {
                                text: '学前赛道',
                                value: '学前赛道'
                            }, {
                                text: 'K12赛道',
                                value: 'K12赛道'
                            }]
                        }
                        onFilter={(value, record) => record.category === value}
                        render={value=><span><UserOutlined /> {value}</span>}
                    />
                    <Table.Column
                        dataIndex="bu"
                        key="bu"
                        width={120}
                        title="所属业务线"
                        filters={
                            [{
                                text: '*通用*',
                                value: '通用'
                            }, {
                                text: '薄荷芝士派',
                                value: '薄荷芝士派'
                            }, {
                                text: '柚子鸭',
                                value: '柚子鸭'
                            }, {
                                text: '百词斩',
                                value: '百词斩'
                            }, {
                                text: '夜曲编程',
                                value: '夜曲编程'
                            }, {
                                text: '蛋糕英语',
                                value: '蛋糕英语'
                            }]
                        }
                        onFilter={(value, record) => record.bu === value}
                        render={value=><span style={{color: this.buColors[value]}}>{value}</span> }
                    />
                    <Table.Column
                        dataIndex="definition"
                        key="definition"
                        width={300}
                        ellipsis
                        title="指标定义&口径说明"
                        render={value=><span style={{color: '#595959'}}>{value}</span>}
                    />
                    <Table.Column dataIndex="dimension" key="dimension" width={300} ellipsis title="分析维度" />
                    <Table.Column dataIndex="process" key="process" width={200} title="所属业务过程" />
                    <Table.Column
                        dataIndex="area"
                        key="area"
                        width={120}
                        title="所属主题"
                        filters={
                            [{
                                text: '用户域',
                                value: '用户域'
                            }, {
                                text: '交易域',
                                value: '交易域'
                            }, {
                                text: '流量域',
                                value: '流量域'
                            }, {
                                text: '课程域',
                                value: '课程域'
                            }]
                        }
                        onFilter={(value, record) => record.area === value}
                        render={value=><span style={{color: this.areaColors[value]}}>{value}</span>}
                    />
                    <Table.Column
                        dataIndex="originalTableName"
                        key="originalTableName"
                        width={300}
                        ellipsis
                        title="数据来源"
                        render={value=><code style={{color: '#d4380d'}}>{value}</code>}
                    />
                    <Table.Column
                        dataIndex="productCode"
                        key="productCode"
                        width={300} 
                        ellipsis 
                        title="计算逻辑"
                        render={value=><code>{value}</code>}
                    />
                    <Table.Column dataIndex="owner" key="owner" width={100} title="负责人" />
                    <Table.Column dataIndex="remark" key="remark" width={300} ellipsis title="备注" />
                </Table>
            </Row>
            {this.state.detailModal.visible && <MeasureDetailModal
                {...this.state.detailModal}
                onClose={this.closeMeasureDetail.bind(this)}
                onUpdate={(value) => this.setCoreMeasure(value)}
                onAdd={(value) => this.addCoreMeasure(value)}
                onDelete={(value) => this.deleteCoreMeasure(value)}
            />}
        </>
    }

    showMeasureDetail(desc, showOrCreate) {
        this.setState({
            detailModal: {
                visible: true,
                value: desc,
                readonly: !auth.allow("datap:admin"),
                title: showOrCreate ? '指标详情' : '新建指标',
                showOrCreate: showOrCreate,
            }
        });
    }

    closeMeasureDetail() {
        this.setState(({ detailModal }) => {
            detailModal.visible = false;
            return { detailModal };
        });
    }

    setCoreMeasure(desc) {
        UIFetchService.put(`/api/v1/measure/core/${desc.id}`, desc)
            .then(async () => {
                await this.refreshCoreMeasures();
                message.success(`更新指标"${desc.name}"`);
            });
        this.closeMeasureDetail();
    }

    addCoreMeasure(desc) {
        UIFetchService.post('/api/v1/measure/core', desc)
            .then(async () => {
                await this.refreshCoreMeasures();
                message.success(`增加指标"${desc.name}"`);
            });
        this.closeMeasureDetail();
    }

    deleteCoreMeasure(desc) {
        const onOk = () => {
            UIFetchService.method('DELETE', `/api/v1/measure/core/${desc.id}`)
                .then(async () => {
                    await this.refreshCoreMeasures();
                    message.success(`删除指标"${desc.name}"`);
                });
            this.closeMeasureDetail();
        };
        const onCancel = () => { };

        Modal.confirm({
            title: `是否删除指标: "${desc.name}"`,
            okText: '删除',
            cancelText: '放弃',
            onOk,
            onCancel
        });
    }

    async refreshCoreMeasures() {
        const coreMeasure = await UIFetchService.get('/api/v1/metadata/measure/core/desc');
        this.setState({ coreMeasure });
    }
}

class MeasureDetailModal extends React.Component {
    constructor() {
        super();
        this.state = {
            validate: {}
        };
        this.latestError = 0;
    }

    componentDidMount() {
        //console.log(this.props);
        this.setState(this.props.value);
    }

    render() {
        const formItemStyle = {
            margin: '0px 0px 10px 0px',
        }
        return <Modal
            title={this.props.title}
            visible={this.props.visible}
            onCancel={this.props.onClose}
            footer={!this.props.readonly ? <Row>
                <Col flex="auto"></Col>
                <Col flex="30%">
                    <Space>
                        <Button
                            danger
                            onClick={() => {
                                const value = { ...this.state };
                                delete value.validate;
                                this.props.onDelete(value);
                            }}
                        >删除</Button>
                        {this.props.showOrCreate
                            ? <Button type="primary" onClick={this.commit.bind(this)} >更新</Button>
                            : <Button type="primary" onClick={this.commit.bind(this)} >添加</Button>}
                        <Button onClick={this.props.onClose}>关闭</Button>
                    </Space>
                </Col>
            </Row> : <Row justify="space-around">
                <Col>
                    <Button onClick={this.props.onClose}>确定</Button>
                </Col>
            </Row>}
        >
            <Row justify="space-around">
                <Col flex="100%">
                    <Form
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 20 }}
                        layout="horizontal"
                    >
                        <Form.Item
                            {...this.state.validate.name}
                            label="名称"
                            hasFeedback
                            required
                            style={formItemStyle}
                        >
                            <Input
                                readOnly={this.props.readonly}
                                value={this.state.name}
                                onChange={({ target }) => this.updateField('name', target.value)}
                            ></Input>
                        </Form.Item>
                        <Form.Item
                            label="别名"
                            style={formItemStyle}
                        >
                            <Input
                                readOnly={this.props.readonly}
                                value={this.state.alias}
                                onChange={({ target }) => this.updateField('alias', target.value)}
                            ></Input>
                        </Form.Item>
                        <Form.Item
                            {...this.state.validate.category}
                            label="所属赛道"
                            required
                            style={formItemStyle}
                        >
                            <Select
                                value={this.state.category}
                                defaultValue=""
                                disabled={this.props.readonly}
                                onChange={category => this.updateField('category', category)}
                            >
                                <Select.Option value="">[未选择]</Select.Option>
                                <Select.Option value="通用">*通用*</Select.Option>
                                <Select.Option value="成人赛道">成人赛道</Select.Option>
                                <Select.Option value="学前赛道">学前赛道</Select.Option>
                                <Select.Option value="K12赛道">K12赛道</Select.Option>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            {...this.state.validate.bu}
                            label="所属业务线"
                            required
                            style={formItemStyle}
                        >
                            <Select
                                value={this.state.bu}
                                defaultValue=""
                                disabled={this.props.readonly}
                                onChange={bu => this.updateField('bu', bu)}
                            >
                                <Select.Option value="">[未选择]</Select.Option>
                                <Select.Option value="通用">*通用*</Select.Option>
                                <Select.Option value="薄荷芝士派">薄荷芝士派</Select.Option>
                                <Select.Option value="柚子鸭">柚子鸭</Select.Option>
                                <Select.Option value="百词斩">百词斩</Select.Option>
                                <Select.Option value="夜曲编程">夜曲编程</Select.Option>
                                <Select.Option value="蛋糕英语">蛋糕英语</Select.Option>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            {...this.state.validate.definition}
                            label="口径说明"
                            required
                            style={formItemStyle}
                        >
                            <Input.TextArea
                                readOnly={this.props.readonly}
                                value={this.state.definition}
                                onChange={({ target }) => this.updateField('definition', target.value)}
                                rows={2}
                            ></Input.TextArea>
                        </Form.Item>
                        <Form.Item
                            label="分析维度"
                            style={formItemStyle}
                        >
                            <Input
                                readOnly={this.props.readonly}
                                value={this.state.dimension}
                                onChange={({ target }) => this.updateField('dimension', target.value)}
                            ></Input>
                        </Form.Item>
                        <Form.Item
                            label="所属业务过程"
                            style={formItemStyle}
                        >
                            <Input
                                readOnly={this.props.readonly}
                                value={this.state.process}
                                onChange={({ target }) => this.updateField('process', target.value)}
                            ></Input>
                        </Form.Item>
                        <Form.Item
                            {...this.state.validate.area}
                            label="所属主题"
                            required
                            style={formItemStyle}
                        >
                            <Select
                                value={this.state.area}
                                defaultValue=""
                                disabled={this.props.readonly}
                                onChange={area => this.updateField('area', area)}
                            >
                                <Select.Option value="">[未选择]</Select.Option>
                                <Select.Option value="用户域">用户域</Select.Option>
                                <Select.Option value="交易域">交易域</Select.Option>
                                <Select.Option value="流量域">流量域</Select.Option>
                                <Select.Option value="课程域">课程域</Select.Option>
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="数据来源"
                            style={formItemStyle}
                        >
                            <Input
                                readOnly={this.props.readonly}
                                value={this.state.originalTableName}
                                onChange={({ target }) => this.updateField('originalTableName', target.value)}
                            ></Input>
                        </Form.Item>
                        <Form.Item
                            label="计算逻辑"
                            style={formItemStyle}
                        >
                            <Input.TextArea
                                readOnly={this.props.readonly}
                                value={this.state.productCode}
                                onChange={({ target }) => this.updateField('productCode', target.value)}
                                rows={2}
                            ></Input.TextArea>
                        </Form.Item>
                        <Form.Item
                            {...this.state.validate.owner}
                            label="负责人"
                            required
                            style={formItemStyle}
                        >
                            <Input
                                readOnly={this.props.readonly}
                                value={this.state.owner}
                                onChange={({ target }) => this.updateField('owner', target.value)}
                            ></Input>
                        </Form.Item>
                        <Form.Item
                            label="备注"
                            style={formItemStyle}
                        >
                            <Input.TextArea
                                readOnly={this.props.readonly}
                                value={this.state.remark}
                                onChange={({ target }) => this.updateField('remark', target.value)}
                                rows={1}
                            ></Input.TextArea>
                        </Form.Item>
                    </Form>
                </Col>
            </Row>
        </Modal>;
    }

    updateField(name, value) {
        if (this.latestError > 0) {
            this.validate(name, value);
        }
        const update = {};
        update[name] = value;
        if (name === 'category' && value === '通用') {
            update.bu = '通用';
        }
        this.setState(update);
    }

    commit() {
        this.latestError = this.validate();
        if (this.latestError > 0) {
            return;
        }

        const value = { ...this.state };
        delete value.validate;
        if (this.props.showOrCreate) {
            this.props.onUpdate(value);
        } else {
            this.props.onAdd(value);
        }
    }

    validate(name, value) {
        const requiredFields = {
            name: '名字不能未空',
            category: '赛道不能为空',
            bu: '所属业务线不能为空',
            definition: '口径说明不能为空',
            area: '所属主题不能为空',
            owner: '负责人不能为空'
        };
        const validate = {};
        let err = 0;
        for (let key of Object.keys(requiredFields)) {
            if (name !== undefined && name === key) {
                if (isEmpty(value)) {
                    validate[key] = {
                        validateStatus: 'error',
                        help: requiredFields[key]
                    };
                    err++;
                }
            } else if (isEmpty(this.state[key])) {
                validate[key] = {
                    validateStatus: 'error',
                    help: requiredFields[key]
                };
                err++;
            }
        }

        this.setState({ validate });
        return err;
    }
}

export default MeasureDescView;